import callAny from './call_any'
import { select } from 'redux-saga/effects'

import myLibraryUserDataSelector from 'redux/selectors/my_library/my_library_userData_selector'
import { myLibrarySync } from 'sync'

function *launchLiveLesson(presentationUid, isNew, lms) {

	const userData = yield select(myLibraryUserDataSelector)
	const response = yield callAny(
		myLibrarySync.launchMyLibraryLiveLesson,
		'ipad',
		presentationUid,
		'tabc',
		'',
		isNew,
		userData.jwt,
		lms
	)

	return response
}

export default launchLiveLesson
